import React, { SVGProps } from 'react'
const SvgCardCreateLabel = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M18.468 10.5H4.664c-.622 0-1.129.344-1.129.767v6.466c0 .423.507.767 1.13.767h13.803c.623 0 1.13-.344 1.13-.767v-6.466c0-.423-.507-.767-1.13-.767Z"
      />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M18.468 7H4.664C3.746 7 3 7.697 3 8.554v8.892C3 18.303 3.746 19 4.664 19h13.804c.918 0 1.665-.697 1.665-1.554V8.554c0-.857-.747-1.554-1.665-1.554ZM4.664 8h13.804c.327 0 .594.25.594.554v8.892c0 .305-.267.554-.594.554H4.664c-.326 0-.593-.25-.593-.554V8.554c0-.305.267-.554.593-.554Z"
      />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M18.468 7H4.664C3.746 7 3 7.697 3 8.554V11.5h17.133V8.554c0-.857-.747-1.554-1.665-1.554Zm0 1 .096.007c.282.043.498.273.498.547V10.5H4.07V8.554c0-.305.267-.554.593-.554h13.804ZM16.652 15c.296 0 .536.224.536.5a.51.51 0 0 1-.44.492l-.096.008h-2.944c-.296 0-.536-.224-.536-.5 0-.245.19-.45.44-.492l.096-.008h2.944Z"
      />
      <path fill="#FFF" d="M17.83 14h3.212v3H17.83z" />
      <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
        <path d="M22.75 16c.296 0 .536-.223.536-.5a.51.51 0 0 0-.439-.491L22.751 15h-7.276c-.296 0-.536.223-.536.5 0 .245.19.45.44.492l.096.008h7.276Z" />
        <path d="M21.314 18.064a.565.565 0 0 0 .686-.02l.066-.066 1.82-2.169a.473.473 0 0 0 .056-.535l-.056-.082-1.82-2.17a.561.561 0 0 0-.752-.086.479.479 0 0 0-.144.627l.053.075 1.562 1.863-1.562 1.86a.475.475 0 0 0 .02.64l.071.063Z" />
      </g>
    </g>
  </svg>
)
export default SvgCardCreateLabel
